// OTPVerificationForm.jsx
import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import backArrowSVG from "../../assets/images/back-arrow.svg";
import { verfiyUser } from "../../store/Slice/AuthSlice";
import { useDispatch } from "react-redux";

const OTPVerificationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const [data, setData] = useState(location.state);
  const { sessionId, mobileNumber } = data;

  const [error, setError] = useState("");
  const [otp, setOTP] = useState(["", "", "", "", "", ""]); 
  const inputRefs = useRef([]);

  const handleSubmit = async () => {

    try {
      const response = await dispatch(
        verfiyUser({ otp: otp.join(""), mobileNumber })
      ).unwrap();
      try {
        const { userExists, token } = response;
        if (token) {
          document.cookie = `authToken=${token}; expires=${1}; path=/`;
        }
        if (userExists) {
          if (response?.user?.Id) {
            localStorage.setItem("userID", response.user.Id);
          }
          // dispatch(postLoginData());
          // navigate(`/dashboard?action=login&type=login&status=success&request_token=${sessionId}`);
          navigate(`/dashboard`);
        } else {
          console.log("mobileNumber in OTPVerForm: ", mobileNumber);
          navigate("/onboarding", { state: { phoneNumber: mobileNumber } });
        }
      } catch (error) {
        console.log("Error:", error);
      }
    } catch (error) {}
  };

  // Function to handle OTP input change
  const handleChange = (index, value) => {
    if (isNaN(value)) return; // Only allow numeric input
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);
    // console.log(otp);

    // Move focus to next input field if current input is filled
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Function to handle OTP input on paste
  const handlePaste = (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData
      .getData("text/plain")
      .split("")
      .filter((char) => !isNaN(char));
    const newOTP = [...otp];
    pastedData.forEach((char, index) => {
      if (index < otp.length) {
        newOTP[index] = char;
      }
    });
    setOTP(newOTP);
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      event.preventDefault();
      const newOTP = [...otp];

      if (newOTP[index]) {
        newOTP[index] = "";
        setOTP(newOTP);
        return;
      }

      if (index > 0) {
        newOTP[index - 1] = "";
        setOTP(newOTP);
        inputRefs.current[index - 1]?.focus();
      }
      return;
    }

    if (event.key === "ArrowLeft" && index > 0) {
      event.preventDefault();
      inputRefs.current[index - 1]?.focus();
    }

    if (event.key === "ArrowRight" && index < otp.length - 1) {
      event.preventDefault();
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className='flex items-center justify-center text-[#454545] font-["Roboto",sans-serif] h-screen bg-gradient-to-br from-[#1569AB] via-[#1569AB] to-[#1E8C45]'>
      <div className="flex flex-col font-['Roboto',sans-serif] w-[32.6875rem] mx-auto bg-white p-6 rounded-lg gap-8 shadow-[0_0_10px_rgba(0,0,0,0.1)] max-md:w-full max-md:rounded-none">
        <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
          <div
            className="flex items-center justify-center rounded-lg border border-[#939393] bg-white p-3.5 max-md:p-2.5 cursor-pointer"
            onClick={handleBackButtonClick}
          >
            <img src={backArrowSVG} width={24} height={24} alt="Back" />
          </div>
          <div>
            <h2 className="text-[#454545] font-['Roboto'] text-[23px] font-bold leading-normal mb-2 max-md:text-xl">
              Create Account
            </h2>
            <p className="text-[#9D9D9D] font-['Roboto'] text-[15px] font-normal leading-normal max-md:text-xs">
              You received OTP to your mobile number
            </p>
          </div>
        </div>
        <hr className="border-[0.6px] border-[#EBEBEB] -mt-4" />
        <div>
          <p className="text-[#454545] text-base font-normal leading-normal mb-5">
            Enter received OTP
          </p>
          <div className="flex justify-between">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(ref) => (inputRefs.current[index] = ref)}
                type="text"
                placeholder="0"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
                className="font-['Roboto'] text-base font-normal leading-normal text-center max-w-[60px] flex h-11 py-2.5 px-3 justify-center items-center gap-2 flex-1 rounded-lg border border-brand-border bg-white max-[425px]:text-[0.85rem] max-[425px]:py-[7px] max-[425px]:px-[9px] max-[425px]:h-[33px] max-[425px]:max-w-[45px]"
              />
            ))}
          </div>
          {error && (
            <span className="text-red-600 font-['Roboto',sans-serif] text-xs">
              {error}
            </span>
          )}
        </div>
        <div>
          <button
            onClick={handleSubmit}
            className="text-white h-11 py-2.5 px-7 border-none rounded-lg bg-primary cursor-pointer text-base w-full mb-5"
          >
            Submit
          </button>
          <p className="text-[#454545] text-center font-['Roboto'] text-base font-bold leading-normal mb-5">
            OR
          </p>
          <p className="text-[#454545] text-center font-['Roboto'] text-base font-normal leading-normal">
            Did not receive OTP?{" "}
            <a className="text-[#1567A7] font-['Roboto'] text-base font-normal leading-normal no-underline cursor-pointer hover:no-underline">
              Send OTP again.
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OTPVerificationForm;
